var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustom10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59686 9.00557C7.74755 9.00532 7.05872 8.31649 7.05847 7.46718L7.05847 -3.34269e-07L3.07677 -5.08314e-07C1.37745 -5.82594e-07 5.32547e-05 1.37746 7.39737e-07 3.07677L1.34489e-07 16.9232C5.15298e-05 18.6225 1.37745 20 3.07677 20L11.6289 20C13.3281 19.9999 14.7056 18.6225 14.7056 16.9232L14.7056 9.00557L8.59686 9.00557ZM14.7056 6.72633C14.7056 5.80047 14.2883 4.92393 13.57 4.3397L9.08314 0.690135C9.0091 0.629914 8.93217 0.573823 8.85342 0.521082L8.85342 5.31325C8.85363 6.16261 9.54244 6.85142 10.3918 6.85163L14.7056 6.85163L14.7056 6.72633Z",
    fill: "url(#paint0_linear_5485_54643)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5485_54643",
    x1: 14.7056,
    y1: 9.99992,
    x2: 0.00000140824,
    y2: 9.99992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3DCE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F9DAA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustom10);
export default __webpack_public_path__ + "static/media/custom-10.d8077efac09a02115418ba7fd1fe3781.svg";
export { ForwardRef as ReactComponent };